import { eTipoPermissao } from '@/enums/ePermissoes';

const permissions = [eTipoPermissao.ALTERACAODEDESIGNACAONOVO_MENU_1400400399];

export default [
  {
    description: 'Alteração de Designação',
    path: '/pessoal/pesalteracaodesignacao',
    name: 'pesalteracaodesignacao',
    component: () => import('@/views/pessoal/pesalteracaodesignacao/Index.vue'),
    meta: {
      permissions,
    },
    goesToMenu: true,
  },
  {
    description: 'Alteração de Designação - Registros',
    path: '/pessoal/pesalteracaodesignacao/:entidade',
    parent: 'pesalteracaodesignacao',
    name: 'pesalteracaodesignacao_list',
    component: () => import('@/views/pessoal/pesalteracaodesignacao/Lista.vue'),
    meta: {
      permissions,
    },
    goesToMenu: false,
  },
  {
    description: 'Cadastro de Alteração de Designação',
    path: '/pessoal/pesalteracaodesignacao/:entidade/cadastro/:id?',
    parent: 'pesalteracaodesignacao_list',
    name: 'pesalteracaodesignacao_create',
    component: () => import('@/views/pessoal/pesalteracaodesignacao/Cadastro.vue'),
    meta: {
      permissions,
    },
    goesToMenu: false,
  },
];
